let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hVsDe")).then(() => parcelRequire('2UWNi'));